export default __webpack_public_path__ + "static/media/oficina-image.b9c084d8.png";